module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMC42NjcgNCA2LjY2NiA5LjMzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik00IDEzLjMzM1Y0TS42NjcgMTAgNCAxMy4zMzMgNy4zMzMgMTAiIHN0cm9rZT0iI0QxNDMzRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/v2/arrow-change-down-no-padding.svg
// module id = HqNE
// module chunks = 0